
import { CreatomateFont, BuiltInFontDefinition } from "./BuiltInFonts";

export const CreatomateProgressiveFonts: CreatomateFont[] = [
  {
    family: "96Sans",
    weight: 400,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans.ttf"
  },
  {
    family: "96Sans-Italic",
    weight: 400,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-Italic.ttf"
  },
  {
    family: "96Sans-Light",
    weight: 300,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-Light.ttf"
  },
  {
    family: "96Sans-LightItalic",
    weight: 300,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-LightItalic.ttf"
  },
  {
    family: "96Sans-Medium",
    weight: 500,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-Medium.ttf"
  },
  {
    family: "96Sans-MediumItalic",
    weight: 500,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-MediumItalic.ttf"
  },
  {
    family: "96Sans-Bold",
    weight: 700,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-Bold.ttf"
  },
  {
    family: "96Sans-BoldItalic",
    weight: 700,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-BoldItalic.ttf"
  },
  {
    family: "96Sans-Heavy",
    weight: 900,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-Heavy.ttf"
  },
  {
    family: "96Sans-HeavyItalic",
    weight: 900,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-HeavyItalic.ttf"
  },
  {
    family: "96Sans-LightCondensed",
    weight: 300,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-LightCondensed.ttf"
  },
  {
    family: "96Sans-LightCondensedItalic",
    weight: 300,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-LightCondensedItalic.ttf"
  },
  {
    family: "96Sans-Condensed",
    weight: 400,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-Condensed.ttf"
  },
  {
    family: "96Sans-CondensedItalic",
    weight: 400,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-CondensedItalic.ttf"
  },
  {
    family: "96Sans-BoldCondensed",
    weight: 700,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-BoldCondensed.ttf"
  },
  {
    family: "96Sans-BoldCondensedItalic",
    weight: 700,
    style: "italic",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-BoldCondensedItalic.ttf"
  },
  {
    family: "96Sans-Monospaced",
    weight: 400,
    style: "normal",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-Monospaced.ttf"
  }
];

export const BuiltInProgressiveFonts: BuiltInFontDefinition[] = [
  {
    family: "96Sans",
    weights: [400],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans.ttf"
  },
  {
    family: "96Sans-Italic",
    weights: [400],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-Italic.ttf"
  },
  {
    family: "96Sans-Light",
    weights: [300],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-Light.ttf"
  },
  {
    family: "96Sans-LightItalic",
    weights: [300],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-LightItalic.ttf"
  },
  {
    family: "96Sans-Medium",
    weights: [500],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-Medium.ttf"
  },
  {
    family: "96Sans-MediumItalic",
    weights: [500],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-MediumItalic.ttf"
  },
  {
    family: "96Sans-Bold",
    weights: [700],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-Bold.ttf"
  },
  {
    family: "96Sans-BoldItalic",
    weights: [700],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-BoldItalic.ttf"
  },
  {
    family: "96Sans-Heavy",
    weights: [900],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-Heavy.ttf"
  },
  {
    family: "96Sans-HeavyItalic",
    weights: [900],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-HeavyItalic.ttf"
  },
  {
    family: "96Sans-LightCondensed",
    weights: [300],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-LightCondensed.ttf"
  },
  {
    family: "96Sans-LightCondensedItalic",
    weights: [300],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-LightCondensedItalic.ttf"
  },
  {
    family: "96Sans-Condensed",
    weights: [400],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-Condensed.ttf"
  },
  {
    family: "96Sans-CondensedItalic",
    weights: [400],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-CondensedItalic.ttf"
  },
  {
    family: "96Sans-BoldCondensed",
    weights: [700],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-BoldCondensed.ttf"
  },
  {
    family: "96Sans-BoldCondensedItalic",
    weights: [700],
    styles: ["italic"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-BoldCondensedItalic.ttf"
  },
  {
    family: "96Sans-Monospaced",
    weights: [400],
    styles: ["normal"],
    category: "other",
    source: "https://culturehq-assets.s3.us-west-2.amazonaws.com/fonts/progressive/96Sans-Monospaced.ttf"
  }
];
